import { ChangeDetectionStrategy, Component, ViewEncapsulation } from '@angular/core';
@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'ndt-summary-icon',
    templateUrl: './summary-icon.component.html',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class SummaryIconComponent {}
